var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { inputStyle } from "./InputTextStyle";
export var InputNumberStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  > input {\n    ", "\n  }\n"], ["\n  display: block;\n  > input {\n    ", "\n  }\n"])), inputStyle);
var templateObject_1;
//# sourceMappingURL=InputNumberStyled.js.map